//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {payRecordList} from "@/api/contract/payRecord";

export default {
    name: "payRecordList",
  data () {
    return {
      payRecordList: 10,
      refreshing: false,
      loading: false,
      text: 'List',
      checkbox: '',
      tableData:[],
      condition:{
        page:1,
        limit:10,
        payCode:'',
      },
    }
  },
  created () {
    this.getData();
  },
  methods:{
      loadingData(){
        var data={
          'page':this.condition.page,
          'limit':this.condition.limit,
          'payCode':this.condition.payCode,
          'pageType':'lookFor',
        };
        payRecordList(data).then(response => {
          for(var i=0;i<response.data.length;i++){
            this.tableData.push(response.data[i])
          }
        });
      },
      // 查找
    searchEvent(){
      this.getData();
    },
    clearFilter(){
      this.condition.payCode='';
      this.condition.page=1;
      this.getData();
    },
    getData(){
      var data={
        'page':this.condition.page,
        'limit':this.condition.limit,
        'payCode':this.condition.payCode,
        'pageType':'lookFor',
      };
      payRecordList(data).then(response => {
        this.tableData=response.data;
      });
    },
    returnList() {
      this.$router.push({path:'/'})
    },
    refresh () {
      this.refreshing = true
      this.$refs.container.scrollTop = 0
      setTimeout(() => {
        this.refreshing = false
        // this.text = this.text === 'List' ? 'Menu' : 'List'
        this.num = 10
        this.payRecordList = 10
      }, 2000)
    },load () {
      this.loading = true;
      setTimeout(() => {
        this.condition.page++;
        this.loading = false;
        this.loadingData();
      }, 1000)
    },
    detailClick(id,contTypeCode){
      //根据不同的合同类型跳转不同的详情页
      if(contTypeCode=='purchase_contract'){
        this.$router.push({ path:'/payRecord/payPurchaseDetail',query:{id:id}});
      }
      if(contTypeCode=='ctrip_businessTravel'){
        this.$router.push({ path:'/payRecord/payCtripDetail',query:{id:id}});
      }
      if(contTypeCode=='humanDay_outsourcing'){
        this.$router.push({ path:'/payRecord/payHumanDayDetail',query:{id:id}});
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/view/payRecord/payRecordList.vue